import React from 'react';
import PropTypes from 'prop-types';

const SectionProgressBar = ({ gradient, height = '8px', margin = '15px 0', borderRadius = '6px', width = '100%' }) => (
    <div
        style={{
            height,
            background: gradient,
            borderRadius,
            margin,
            width,
            border: 'none'
        }}
    />
);

SectionProgressBar.propTypes = {
    gradient: PropTypes.string.isRequired,
    height: PropTypes.string,
    margin: PropTypes.string,
    borderRadius: PropTypes.string,
    width: PropTypes.string
};

export default SectionProgressBar;
